<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("customer module settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("account module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_every_customer_has_account"
            name="chk_every_customer_has_account"
            v-model="meta.every_customer_has_account"
          />
          <label for="chk_every_customer_has_account">{{
            $t("every customer has an account")
          }}</label>
          <div
            class="button is-rounded is-primary is-small"
            @click="check_customer_account_existance"
          >
            <span class="icon"><i class="fa fa-check"></i></span>
            <span>{{ $t("check") }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('account type')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/account/type/catalog"
            name_field="name"
            value_field="type_id"
            @selected="account_type_changed"
            ref="account_type_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "CustomerSettings",
  components: { GenericDropdown },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    account_type_changed(value) {
      this.meta.account_type_id = value.type_id;
    },
    check_customer_account_existance() {
      let v = this;
      v.$root.loader(true);
      post("/customer/account/existance", {
        account_type_id: v.meta.account_type_id,
      })
        .then(() => {
          success_message(v.$t("check finished"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = conf;
          if (conf.account_type_id)
            v.$refs.account_type_dropdown.set_value(conf.account_type_id);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
